/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { Preference } from '../model/preference';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PreferencesServiceInterface
} from './preferences.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PreferencesService extends BaseService implements PreferencesServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get user preferences
     * Returns the current user\&#39;s preferences. Currently includes notification email settings.  **Enterprise gating:** Returns 403 if the user\&#39;s plan does not have &#x60;notification_control &#x3D; \&#39;Y\&#39;&#x60;. For team members, the owner\&#39;s plan is checked.  **Default behavior:** If the user has no saved preferences record, returns defaults (all notification fields &#x3D; true). This ensures existing users receive all emails until they explicitly opt out. No database record is created on GET.  **Response fields — Notification emails:** | Field | Description | Default | |-------|-------------|---------| | email_you_signed | Email sent to you after you sign a document | true | | email_signature_added_to_your_job | Email sent when a recipient signs a document you sent | true | | email_signature_added_team_job | Email when a recipient signs a document your team member sent (owner only) | true | | email_signature_request_received | Email when someone requests your signature or approval | true | | email_job_completed_you_sent | Email when all signatures are collected on a document you sent | true | | email_job_completed_team_sent | Email when signing completes on a team member\&#39;s document (owner only) | true | | email_sftp_transfer_your_job | Email when an SFTP transfer succeeds for your document | true | | email_sftp_transfer_team_job | Email when an SFTP transfer succeeds for a team member\&#39;s document (owner only) | true | | email_daily_digest | Enable daily digest email summarizing signing activity | true | | daily_digest_hour | Hour of day (7-19) to send the daily digest email | 16 |  **Note:** Error notifications (e.g., SFTP transfer failures) are always sent and cannot be disabled. 
     * @param accessToken System access token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersPreferencesGet(accessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Preference>;
    public usersPreferencesGet(accessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Preference>>;
    public usersPreferencesGet(accessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Preference>>;
    public usersPreferencesGet(accessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling usersPreferencesGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/users/preferences`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Preference>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update user preferences
     * Updates the current user\&#39;s preferences. Send only the fields you want to change — omitted fields retain their current values.  **Enterprise gating:** Returns 403 if the user\&#39;s plan does not have &#x60;notification_control &#x3D; \&#39;Y\&#39;&#x60;. For team members, the owner\&#39;s plan is checked.  **First update:** If no preferences record exists, one is created with all defaults (all notification fields &#x3D; true), then the provided fields are applied.  **Partial update:** Only fields included in the request are updated. For example, sending only &#x60;email_you_signed&#x3D;false&#x60; changes that single field; the other 7 are unchanged.  **Field descriptions:** | Field | Type | Description | |-------|------|-------------| | email_you_signed | boolean | You signed a document | | email_signature_added_to_your_job | boolean | Signature added to your job | | email_signature_added_team_job | boolean | Signature added to team member\&#39;s job (owner only) | | email_signature_request_received | boolean | Signing/approval request received | | email_job_completed_you_sent | boolean | Signing completed (your job) | | email_job_completed_team_sent | boolean | Signing completed (team member\&#39;s job, owner only) | | email_sftp_transfer_your_job | boolean | Successful SFTP transfer (your job) | | email_sftp_transfer_team_job | boolean | Successful SFTP transfer (team member\&#39;s job, owner only) | | email_daily_digest | boolean | Enable daily digest email summarizing signing activity | | daily_digest_hour | integer | Hour of day (7-19) to send the daily digest email | 
     * @param accessToken System access token
     * @param emailYouSigned Receive email after you sign a document. Default: true
     * @param emailSignatureAddedToYourJob Receive email when a recipient signs a document you sent. Default: true
     * @param emailSignatureAddedTeamJob Receive email when a recipient signs a team member\\\&#39;s document (owner only). Default: true
     * @param emailSignatureRequestReceived Receive email when someone requests your signature. Default: true
     * @param emailJobCompletedYouSent Receive email when signing completes on a document you sent. Default: true
     * @param emailJobCompletedTeamSent Receive email when signing completes on a team member\\\&#39;s document (owner only). Default: true
     * @param emailSftpTransferYourJob Receive email when SFTP transfer succeeds for your document. Default: true
     * @param emailSftpTransferTeamJob Receive email when SFTP transfer succeeds for a team member\\\&#39;s document (owner only). Default: true
     * @param emailDailyDigest Enable daily digest email summarizing signing activity. Default: true
     * @param dailyDigestHour Hour of day (7-19) to send the daily digest email. Default: 16
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersPreferencesPut(accessToken: string, emailYouSigned?: boolean, emailSignatureAddedToYourJob?: boolean, emailSignatureAddedTeamJob?: boolean, emailSignatureRequestReceived?: boolean, emailJobCompletedYouSent?: boolean, emailJobCompletedTeamSent?: boolean, emailSftpTransferYourJob?: boolean, emailSftpTransferTeamJob?: boolean, emailDailyDigest?: boolean, dailyDigestHour?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Preference>;
    public usersPreferencesPut(accessToken: string, emailYouSigned?: boolean, emailSignatureAddedToYourJob?: boolean, emailSignatureAddedTeamJob?: boolean, emailSignatureRequestReceived?: boolean, emailJobCompletedYouSent?: boolean, emailJobCompletedTeamSent?: boolean, emailSftpTransferYourJob?: boolean, emailSftpTransferTeamJob?: boolean, emailDailyDigest?: boolean, dailyDigestHour?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Preference>>;
    public usersPreferencesPut(accessToken: string, emailYouSigned?: boolean, emailSignatureAddedToYourJob?: boolean, emailSignatureAddedTeamJob?: boolean, emailSignatureRequestReceived?: boolean, emailJobCompletedYouSent?: boolean, emailJobCompletedTeamSent?: boolean, emailSftpTransferYourJob?: boolean, emailSftpTransferTeamJob?: boolean, emailDailyDigest?: boolean, dailyDigestHour?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Preference>>;
    public usersPreferencesPut(accessToken: string, emailYouSigned?: boolean, emailSignatureAddedToYourJob?: boolean, emailSignatureAddedTeamJob?: boolean, emailSignatureRequestReceived?: boolean, emailJobCompletedYouSent?: boolean, emailJobCompletedTeamSent?: boolean, emailSftpTransferYourJob?: boolean, emailSftpTransferTeamJob?: boolean, emailDailyDigest?: boolean, dailyDigestHour?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling usersPreferencesPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (emailYouSigned !== undefined && emailYouSigned !== null) {
            localVarFormParams = localVarFormParams.append('email_you_signed', <any>emailYouSigned) as any || localVarFormParams;
        }
        if (emailSignatureAddedToYourJob !== undefined && emailSignatureAddedToYourJob !== null) {
            localVarFormParams = localVarFormParams.append('email_signature_added_to_your_job', <any>emailSignatureAddedToYourJob) as any || localVarFormParams;
        }
        if (emailSignatureAddedTeamJob !== undefined && emailSignatureAddedTeamJob !== null) {
            localVarFormParams = localVarFormParams.append('email_signature_added_team_job', <any>emailSignatureAddedTeamJob) as any || localVarFormParams;
        }
        if (emailSignatureRequestReceived !== undefined && emailSignatureRequestReceived !== null) {
            localVarFormParams = localVarFormParams.append('email_signature_request_received', <any>emailSignatureRequestReceived) as any || localVarFormParams;
        }
        if (emailJobCompletedYouSent !== undefined && emailJobCompletedYouSent !== null) {
            localVarFormParams = localVarFormParams.append('email_job_completed_you_sent', <any>emailJobCompletedYouSent) as any || localVarFormParams;
        }
        if (emailJobCompletedTeamSent !== undefined && emailJobCompletedTeamSent !== null) {
            localVarFormParams = localVarFormParams.append('email_job_completed_team_sent', <any>emailJobCompletedTeamSent) as any || localVarFormParams;
        }
        if (emailSftpTransferYourJob !== undefined && emailSftpTransferYourJob !== null) {
            localVarFormParams = localVarFormParams.append('email_sftp_transfer_your_job', <any>emailSftpTransferYourJob) as any || localVarFormParams;
        }
        if (emailSftpTransferTeamJob !== undefined && emailSftpTransferTeamJob !== null) {
            localVarFormParams = localVarFormParams.append('email_sftp_transfer_team_job', <any>emailSftpTransferTeamJob) as any || localVarFormParams;
        }
        if (emailDailyDigest !== undefined && emailDailyDigest !== null) {
            localVarFormParams = localVarFormParams.append('email_daily_digest', <any>emailDailyDigest) as any || localVarFormParams;
        }
        if (dailyDigestHour !== undefined && dailyDigestHour !== null) {
            localVarFormParams = localVarFormParams.append('daily_digest_hour', <any>dailyDigestHour) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/users/preferences`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Preference>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
